import * as React from 'react';
import styles from './index.less';
import { getMicroAppName } from '@/constants';
import { initGlobalState, MicroAppStateActions } from 'qiankun';
import * as AHooks from 'ahooks';
import { MicroApp } from 'umi';
import ReactDOM from 'react-dom';

const EMPTY_AUTH_EXCLUDED_ITEMS: TAuthExcludedItems = [];

type TAuthExcludedItems = {
  resourceID: string;
  resourceName: string;
  contracts: {
    policyID: string;
    contractID: string;
  }[];
}[];

interface IData {
  resourceId: string;
  authExcludedItems: TAuthExcludedItems;
  isAllAuthComplete: boolean;
}

interface FContractHandleDrawerProps {
  open: number;
  licensorId: string;
  itemId?: string;
  authExcludedItems?: TAuthExcludedItems;
  licenseeId: string;
  onMount?(data: IData): void;
  onUpdate?(data: IData): void;
  // onClose?(data: IData): void;
  onClose?(): void;
}

const state: {
  authProcessorShow: boolean;
  licensorId: string;
  itemId: string;
  authExcludedItems: TAuthExcludedItems;
} = {
  // 授权处理器弹窗显示
  authProcessorShow: false,
  // 授权方 id
  licensorId: '',
  itemId: '',
  authExcludedItems: [],
};

const actions: MicroAppStateActions = initGlobalState(state);

export function FContractHandleDrawer({
  open,
  licensorId,
  itemId = '',
  authExcludedItems = EMPTY_AUTH_EXCLUDED_ITEMS,
  licenseeId,
  onMount,
  onUpdate,
  onClose,
}: FContractHandleDrawerProps) {

  AHooks.useMount(() => {
    actions.setGlobalState({
      authProcessorShow: open !== 0,
      licensorId: licensorId,
      itemId: itemId,
      authExcludedItems: authExcludedItems,
    });
  });

  AHooks.useDebounceEffect(
    () => {
      actions.setGlobalState({
        authProcessorShow: open !== 0,
      });
    },
    [open],
    {
      wait: 100,
    },
  );

  AHooks.useDebounceEffect(
    () => {
      actions.setGlobalState({
        licensorId: licensorId,
        itemId: itemId,
        authExcludedItems: authExcludedItems,
      });
    },
    [licensorId, itemId, authExcludedItems],
    {
      wait: 100,
    },
  );

  if (licenseeId === '') {
    return null;
  }

  return ReactDOM.createPortal(
    <MicroApp
      name={
        getMicroAppName('CollectionSignItems')
      }
      mainAppType={'resourcesPool'}
      licenseeId={licenseeId}
      mainAppFuncs={{
        update(options: { authExcludedItems: TAuthExcludedItems; isAllAuthComplete: boolean }) {
          onUpdate?.({
            resourceId: licensorId,
            authExcludedItems: options.authExcludedItems ?? [],
            isAllAuthComplete: options.isAllAuthComplete ?? true,
          });
        },
        onClose() {
          onClose?.();
        },
      }}
    />,
    // self.document.getElementById('FContractHandleDrawer') as HTMLElement,
    self.document.body,
  );
}

export default FContractHandleDrawer;
